"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BBUserSettings = void 0;
var auth_1 = require("../auth");
var csrf_xhr_1 = require("../shared/csrf-xhr");
var URL = 'https://sky-pusa01.app.blackbaud.net/uicfg/settings/user';
var updateTimeoutId;
var BBUserSettings = /** @class */ (function () {
    function BBUserSettings() {
    }
    BBUserSettings.getSettings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var token, timeoutId, value, err_1, err_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 6, , 7]);
                                    return [4 /*yield*/, auth_1.BBAuth.getToken({
                                            disableRedirect: true,
                                        })];
                                case 1:
                                    token = _a.sent();
                                    timeoutId = setTimeout(reject, this.GET_SETTINGS_TIMEOUT);
                                    _a.label = 2;
                                case 2:
                                    _a.trys.push([2, 4, , 5]);
                                    return [4 /*yield*/, csrf_xhr_1.BBCsrfXhr.requestWithToken(URL, token)];
                                case 3:
                                    value = _a.sent();
                                    clearTimeout(timeoutId);
                                    resolve(value.settings);
                                    return [3 /*break*/, 5];
                                case 4:
                                    err_1 = _a.sent();
                                    reject();
                                    return [3 /*break*/, 5];
                                case 5: return [3 /*break*/, 7];
                                case 6:
                                    err_2 = _a.sent();
                                    // User is not logged in; return local settings.
                                    try {
                                        resolve(this.getLocalSettings());
                                    }
                                    catch (err) {
                                        reject();
                                    }
                                    return [3 /*break*/, 7];
                                case 7: return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    BBUserSettings.updateSettings = function (correlationId, settings) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (updateTimeoutId) {
                            clearTimeout(updateTimeoutId);
                            updateTimeoutId = undefined;
                        }
                        updateTimeoutId = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                            var token, err_3, err_4, existingSettings;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        updateTimeoutId = undefined;
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 7, , 8]);
                                        return [4 /*yield*/, auth_1.BBAuth.getToken({
                                                disableRedirect: true,
                                            })];
                                    case 2:
                                        token = _a.sent();
                                        _a.label = 3;
                                    case 3:
                                        _a.trys.push([3, 5, , 6]);
                                        return [4 /*yield*/, csrf_xhr_1.BBCsrfXhr.requestWithToken(URL, token, 'PATCH', {
                                                correlationId: correlationId,
                                                settings: settings,
                                            })];
                                    case 4:
                                        _a.sent();
                                        resolve();
                                        return [3 /*break*/, 6];
                                    case 5:
                                        err_3 = _a.sent();
                                        reject(err_3);
                                        return [3 /*break*/, 6];
                                    case 6: return [3 /*break*/, 8];
                                    case 7:
                                        err_4 = _a.sent();
                                        existingSettings = void 0;
                                        try {
                                            existingSettings = this.getLocalSettings();
                                        }
                                        catch (err) {
                                            existingSettings = {};
                                        }
                                        try {
                                            existingSettings.omnibar = existingSettings.omnibar || {};
                                            Object.assign(existingSettings.omnibar, settings.omnibar);
                                            localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(existingSettings));
                                        }
                                        catch (err) {
                                            reject();
                                        }
                                        return [3 /*break*/, 8];
                                    case 8: return [2 /*return*/];
                                }
                            });
                        }); }, _this.UPDATE_DELAY);
                    })];
            });
        });
    };
    BBUserSettings.getLocalSettings = function () {
        return JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_KEY));
    };
    BBUserSettings.UPDATE_DELAY = 1000;
    BBUserSettings.GET_SETTINGS_TIMEOUT = 5000;
    BBUserSettings.LOCAL_STORAGE_KEY = 'auth-client-local-user-settings';
    return BBUserSettings;
}());
exports.BBUserSettings = BBUserSettings;
